module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="livechat-warning-wrapper">\r\n    <div class="livechat-warning-header">\r\n        <h3>Are you sure?</h3>\r\n    </div>\r\n    <p class="livechat-warning-text">\r\n        ' +
((__t = (decliningBoxText )) == null ? '' : __t) +
'\r\n    </p>\r\n\r\n    <div class="apexchat_consent_action">\r\n        <div class="livechat_btn livechat_btn_less_round">\r\n            <button class="livechat_consent_agree livechat_btn_item" tabindex="0">\r\n                ' +
((__t = (acceptText )) == null ? '' : __t) +
'\r\n            </button>\r\n        </div>\r\n        <div class="livechat_btn livechat_btn_less_round">\r\n            <button class="livechat_consent_deny livechat_btn_item livechat_btn_item_gray" tabindex="0">\r\n                ' +
((__t = (rejectText )) == null ? '' : __t) +
'\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}